import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { Province } from '../models/province.model';
import { GeneralService } from './general.service';
import { environment } from '../../environments/environment';
import { PersistenceService } from 'angular-persistence';
import { HttpParams } from '@angular/common/http';
import { SelectItem } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { Observable } from 'rxjs/Observable';
import { ResponseModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class VehicleServices extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiPostUrl, "Vehicle");
  }

  public getVehicle(isDelivery?: any, isTransfer?: any): Observable<ResponseModel> {
    let params = new HttpParams();
    if (isDelivery) {
      params = params.append("isDelivery", isDelivery)
    }
    if (isTransfer) {
      params = params.append("isTransfer", isTransfer)
    }

    return super.getCustomApi("getVehicle", params);
  }

  async getAllSelectModelAsync(isDelivery?: any, isTransfer?: any): Promise<SelectItem[]> {
    const res = await this.getVehicle(isDelivery, isTransfer).toPromise();
    if (res.isSuccess) {
      const data = res.data as any[];
      if (data) {
        const vehicles: SelectItem[] = [];
        vehicles.push({
          label: `-- Chọn loại xe --`,
          value: null
        });
        data.forEach(element => {
          vehicles.push({
            label: `${element.code} - ${element.name}`,
            value: element.id
          });
        });
        return vehicles;
      }
    } else {
      return null;
    }
  }

  async getAllSelectModelNoneNullAsync(isDelivery?: any, isTransfer?: any): Promise<SelectItem[]> {
    const res = await this.getVehicle(isDelivery, isTransfer).toPromise();
    if (res.isSuccess) {
      const data = res.data as any[];
      if (data) {
        const vehicles: SelectItem[] = [];
        data.forEach(element => {
          vehicles.push({
            label: `${element.code} - ${element.name}`,
            value: element.id
          });
        });
        return vehicles;
      }
    } else {
      return null;
    }
  }
}